import { render, staticRenderFns } from "./AccreditedBuilderActivitiesTimelineItem.vue?vue&type=template&id=5a09e86c"
import script from "./AccreditedBuilderActivitiesTimelineItem.vue?vue&type=script&lang=js"
export * from "./AccreditedBuilderActivitiesTimelineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports